import * as React from "react";
import { ScrollFade } from "../scroll-fade/scroll-fade.mjs";
import { useHorizontalScroll } from "./use-horizontal-scroll.mjs";
const HorizontalScroll = (props) => {
  const containerRef = React.useRef(null);
  const elementsRef = React.useRef([]);
  const { scrollTo } = useHorizontalScroll({ containerRef, elementsRef });
  const BEM = () => {
    const classArray = ["horizontal-scroll"];
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(
    ScrollFade,
    {
      hasArrows: true,
      ...props.scrollFadeProps,
      onArrowClick: (_, direction) => scrollTo(direction),
      elementRef: (el) => containerRef.current = el
    },
    /* @__PURE__ */ React.createElement("div", { className: BEM(), style: { gap: props.spaceBetweenElements } }, React.Children.map(props.children, (child, index) => /* @__PURE__ */ React.createElement("div", { ref: (el) => elementsRef.current[index] = el, className: "horizontal-scroll__item" }, child)))
  );
};
export {
  HorizontalScroll,
  useHorizontalScroll
};
